<div class="cfo-kpi" *ngIf="spec_; else fallbackTpl">

  <h4 class="cfo-kpi__title" *ngIf="spec_.title">{{ spec_.title }}</h4>

  <div class="cfo-kpi__grid" [ngClass]="gridClass">
    <div class="cfo-kpi__tile"
         *ngFor="let tile of spec_.tiles; trackBy: trackByIndex">
      <div class="cfo-kpi__tile-label">{{ tile.label }}</div>
      <div class="cfo-kpi__tile-value" [style.color]="valueColor(tile)">{{ tile.value }}</div>
      <div class="cfo-kpi__tile-hint" *ngIf="tile.hint">{{ tile.hint }}</div>
      <div class="cfo-kpi__tile-trend"
           *ngIf="tile.trend"
           [style.color]="trendColor(tile.trend)">{{ tile.trend }}</div>
    </div>
  </div>

</div>

<ng-template #fallbackTpl>
  <div class="cfo-kpi__error" *ngIf="errorRaw">
    No se pudo renderizar el panel de KPIs.
  </div>
</ng-template>
